import { v4 as UUID } from 'uuid'

const getDirectToken = () => {
  let token = localStorage.getItem('directFlowToken')

  if (token === null) {
    token = UUID()
    localStorage.setItem('directFlowToken', token)
  }

  return token.replaceAll('"', '')
}

/**
 * This is used to progressively rollout the direct flow,
 * this code should be removed when we roll the new direct flow completely
 */
export const directFlowToken = getDirectToken()
